import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const containerVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.04 },
  },
};

export const riseVariants = {
  hidden: { opacity: 0, y: 42 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: EASE },
  },
};

/** Reveal — staggered container that animates its Rise children on scroll. */
export function Reveal({ children, className = "", amount = 0.2, as = "div", ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
      {...rest}
    >
      {children}
    </Comp>
  );
}

/** Rise — single fade + rise item, must live inside a Reveal. */
export function Rise({ children, className = "", as = "div", ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp className={className} variants={riseVariants} {...rest}>
      {children}
    </Comp>
  );
}
